<template>
  <div class="document_index">
    <page-header :title="$tc('document.name', 2)">
    </page-header>
    <page-content>
      <ntm-block>
        <template slot="options">
<!--          <input type="text" class="form-control" :placeholder="$tc('search')"  v-model="search">-->
          <button @click="createPage()" type="button" class="btn btn-sm btn-success">{{$t('action.addNew')}}</button>
        </template>
        <div class="table-responsive">
          <ntm-table :show-columns="showColumns" :data="model" @pageChange="setPage" :loading="loading">
            <template slot="actions" slot-scope="{row}">
              <router-link :to="{ name: 'documents.edit', params: {uuid: row.uuid }}" class="btn btn-sm btn-primary" v-tooltip="$t('action.edit')">
                <i class="fa fa-pencil"></i>
              </router-link>
            </template>
          </ntm-table>
        </div>
      </ntm-block>
      <!-- END Full Table -->
    </page-content>
  </div>
</template>
<script>
import DocumentService from '@/services/document.service'
import router from '@/router'
import basicIndexMixin from '@/mixins/basic.index.mixin'
export default {
  mixins: [basicIndexMixin],
  data () {
    return {
      showColumns: [
        {
          name: 'name',
          prop: 'name'
        }
      ]
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      DocumentService.index(this.search).then((response) => {
        this.setData(response.data)
      })
    },
    createPage () {
      router.push({ name: 'documents.create' })
    }
  }
}
</script>
